import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Download } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="fixed top-0 w-full z-50 bg-white/80 backdrop-blur-xl border-b border-[#E3E8DC]" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16">
        <a href="#home" className="flex items-center gap-2" data-testid="brand-logo">
          <img
            src="https://static.prod-images.emergentagent.com/jobs/d8a36d0e-acf5-4772-b845-b74bc2191557/images/0a9bc1777adf6f3c4201784effdb03c09d13cbe1b10ecbb42fe5c5571c07a9f7.png"
            alt="Food Safety Partners Logo"
            className="w-14 h-14 object-contain"
          />
          <div className="leading-tight">
            <span className="font-['Outfit'] font-bold text-[#16231A] text-sm block">Food Safety</span>
            <span className="text-[10px] text-[#526B57] tracking-wider uppercase">Partners</span>
          </div>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-[#2B4131] hover:text-[#7CA63A] transition-colors"
              data-testid={`nav-${l.label.toLowerCase().replace(' ', '-')}`}
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/free-checklists"
            className="flex items-center gap-1.5 text-sm font-medium text-[#7CA63A] hover:text-[#68902A] transition-colors"
            data-testid="nav-free-checklists"
          >
            <Download size={14} />
            Free Checklists
          </Link>
          <a
            href="#contact"
            className="bg-[#7CA63A] text-white text-sm font-medium px-5 py-2.5 rounded-full hover:bg-[#68902A] transition-colors"
            data-testid="nav-cta-btn"
          >
            Get Started
          </a>
        </div>

        <button
          className="md:hidden p-2 text-[#16231A]"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-btn"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="md:hidden bg-white border-b border-[#E3E8DC] overflow-hidden"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-4 space-y-3">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block text-sm font-medium text-[#2B4131] hover:text-[#7CA63A] transition-colors py-2"
                >
                  {l.label}
                </a>
              ))}
              <Link
                to="/free-checklists"
                onClick={() => setOpen(false)}
                className="flex items-center gap-1.5 text-sm font-medium text-[#7CA63A] py-2"
              >
                <Download size={14} />
                Free Checklists
              </Link>
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="block bg-[#7CA63A] text-white text-sm font-medium px-5 py-2.5 rounded-full text-center hover:bg-[#68902A] transition-colors"
              >
                Get Started
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
